// apps/web/src/components/analytics/decide/TopVictimSectorsPanel.tsx
//
// P8a Decide tab — sector fallback for the geoSufficiency-failed branch
// of TopVictimCountriesPanel. Same 7d window the geo aggregator used.

import { displayMapper } from '@/lib/display-mapper'

export interface TopVictimSectorsPanelProps {
  sectors: Array<{ sectorSlug: string; count: number }>
  /** True when shown as the geo-insufficiency fallback inside TopVictimCountries */
  isGeoFallback?: boolean
}

export function TopVictimSectorsPanel({ sectors, isGeoFallback }: TopVictimSectorsPanelProps) {
  return (
    <section className="rounded-md border border-border p-4">
      <header className="flex items-baseline justify-between">
        <h2 className="text-sm font-semibold uppercase tracking-wide text-muted-foreground">
          Top victim sectors (last 7d)
        </h2>
      </header>
      {isGeoFallback && sectors.length > 0 && (
        <p className="mt-1 text-xs text-muted-foreground" data-testid="sectors-fallback-reason">
          Limited geographic coverage — showing sectors instead.
        </p>
      )}
      {sectors.length === 0 ? (
        <p className="mt-2 text-sm text-muted-foreground">
          No recent leak-site claims in the last 7 days.
        </p>
      ) : (
        <ol className="mt-3 divide-y divide-border">
          {sectors.map((s) => (
            <li key={s.sectorSlug} className="flex items-center justify-between py-1.5 text-sm">
              <span>{displayMapper.sector(s.sectorSlug)}</span>
              <span className="font-mono text-muted-foreground">{s.count}</span>
            </li>
          ))}
        </ol>
      )}
    </section>
  )
}
